// import sequence is important here
// organize-imports-ignore
import './fetchEnv'
import './storage'
import './callWallet'
import './getAgent'

import { logger } from '@plug-core/logger'
import { setConnectionSessionInterval } from '@core/connectionSessionInterval'
import { setLockInterval } from '@core/lockInterval'

if (!import.meta.env.PROD) {
  logger.addConsoleTransport()
}

setLockInterval()
setConnectionSessionInterval()
